<template>
  <!-- Only inside an active session: `authenticated === true` is false on the login page (post-logout)
       and during a session lock-out (lockOut() clears auth before showing its overlay), so the banner
       never shows there. The deployed-version baseline stays frozen regardless (see auth store). -->
  <q-banner
    v-if="authStore.newVersionAvailable && authStore.authenticated === true"
    inline-actions
    rounded
    class="new-version-banner bg-primary text-white shadow-5"
  >
    <template #avatar>
      <q-icon name="new_releases" color="white" />
    </template>
    Eine neue Version ist verfügbar.
    <template #action>
      <q-btn outline color="white" icon="refresh" label="Neu laden" @click="reload()" />
    </template>
  </q-banner>
</template>

<script setup lang="ts">
import { useAuthStore } from "src/stores/auth"

const authStore = useAuthStore()

// A full reload swaps in the freshly deployed bundle. Navigating to another route auto-reloads too
// (see the router guard), so this is the explicit CTA for users who want it right now.
function reload(): void {
  window.location.reload()
}
</script>

<style scoped>
.new-version-banner {
  position: fixed;
  right: 16px;
  bottom: 16px;
  z-index: 4000;
  max-width: min(420px, calc(100vw - 32px));
}
</style>
